// Known-app logos. Google's Directory API returns no icons, so we map a few
// well-known app names to a domain and ask Google's favicon service for the
// logo. The domain only ever comes from this map, never from the grant, so an
// app's own data can't steer the request. Unknown/internal apps get no icon
// (the row falls back to a letter tile): never guess a domain.
// To add an app: add `'lowercase name': 'domain.tld'` below (or a prefix).

const EXACT = {
  ahaslides: 'ahaslides.com', atlassian: 'atlassian.com', canva: 'canva.com', cursor: 'cursor.com',
  'dlai - learning platform': 'deeplearning.ai', 'draw.io': 'draw.io', dribbble: 'dribbble.com',
  figma: 'figma.com', 'fireflies.ai': 'fireflies.ai', gamma: 'gamma.app', github: 'github.com',
  gitlab: 'gitlab.com', hubspot: 'hubspot.com', mailsuite: 'mailsuite.com', 'mermaid chart': 'mermaidchart.com',
  miro: 'miro.com', ngrok: 'ngrok.com', 'read ai': 'read.ai', render: 'render.com', sentry: 'sentry.io',
  slack: 'slack.com', 'streamlit sharing': 'streamlit.io', testgorilla: 'testgorilla.com', 'tl;dv': 'tldv.io',
  workable: 'workable.com', 'zoho accounts': 'zoho.com', zoom: 'zoom.us', 'workos-sso-google-prod': 'workos.com',
  macos: 'apple.com', ios: 'apple.com', 'ios account manager': 'apple.com', 'android device': 'android.com',
  'google chrome': 'google.com', chromecast: 'google.com',
  notion: 'notion.so', trello: 'trello.com', asana: 'asana.com', loom: 'loom.com', calendly: 'calendly.com',
  dropbox: 'dropbox.com', grammarly: 'grammarly.com', linear: 'linear.app', vercel: 'vercel.com',
  postman: 'postman.com', chatgpt: 'openai.com', openai: 'openai.com',
};

// Lowercase word-prefixes, for families of names (Claude, Claude Code, ...).
// Matches the name itself or the prefix followed by a space, never "Claudette".
const PREFIXES = [['claude', 'claude.ai']];

function domainFor(name) {
  const n = String(name || '').trim().toLowerCase();
  if (!n) return null;
  if (Object.prototype.hasOwnProperty.call(EXACT, n)) return EXACT[n];
  const hit = PREFIXES.find(([p]) => n === p || n.startsWith(`${p} `));
  return hit ? hit[1] : null;
}

export function iconUrlFor(name) {
  const domain = domainFor(name);
  return domain ? `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=64` : null;
}
